<template>
  <div>
    <div
      v-if="customField.input_type === 'select'">
      <r-label
        :is-required="customField.input_config.mandatory"
        :label="customField.title"
        :value="valueCopy"></r-label>
      <div class="select is-fullwidth">
        <select
          @change="updateValue($event.target.value)">
          <option
            :value="null">
            {{ customField.input_config.default ? customField.input_config.default : 'Sélectionnez' }}
          </option>
          <option
            v-for="(val, i) in customField.input_config.available_values"
            :selected="valueCopy ? (valueCopy.value ? valueCopy.value === val.value : valueCopy === val.value) : false"
            :value="val.value"
            :key="i">
            {{ val.label }}
          </option>
        </select>
      </div>
    </div>
    <div
      v-if="customField.input_type === 'multiselect'">
      <div class="field">
        <r-label
          :is-required="customField.input_config.mandatory"
          :label="customField.title"
          :value="valueCopy"></r-label>
        <div
          class="control">
          <multiselect
            v-model="valueCopy"
            label="label"
            track-by="value"
            @input="updateValue($event)"
            :options="customField.input_config.available_values"
            :multiple="true"
            :taggable="true"
            :searchable="false"
            :close-on-select="false"
            :show-labels="false"
            class="multiselect--option-ico is-single_choice"
            :placeholder="''">
            <span slot="noOptions">La liste est vide</span>
            <span
              slot="placeholder"
              class="multiselect__placeholder">{{ customField.input_config.default }}</span>
          </multiselect>
        </div>
      </div>
    </div>
    <div
      v-if="customField.input_type === 'number'">
      <v-input
        v-if="!fromFilter"
        :id="customField.title"
        :name="customField.title"
        step=".01"
        input-type="number"
        :min="0"
        @input="updateValue($event)"
        :model="valueCopy"
        :errors-bag="errors"
        data-vv-value-path="val"
        :data-vv-as="customField.title"
        :has-addons="true">
        <r-label
          slot="label"
          :label="customField.title"
          :is-required="customField.input_config.mandatory"
          :value="valueCopy"></r-label>
        <p
          v-if="customField.input_config.devise"
          class="control"
          slot="addonRight">
          <a class="button is-square is-static is-border">
            <span class="icon"><i class="fas fa-euro-sign"></i></span>
          </a>
        </p>
      </v-input>
      <div
        v-else>
        <r-label
          slot="label"
          :label="customField.input_config.devise ? `${customField.title} (€)` : customField.title "
          :is-required="customField.input_config.mandatory"
          :value="valueCopy"></r-label>
        <div
          class="field has-addons columns">
          <p class="control is-expanded column is-6">
            <v-input
              id="surface_min"
              :name="'surface_min'"
              @input="updateValueNumber($event, 'is_on__gte')"
              :model="valueCopy && valueCopy['is_on__gte'] || null"
              :number="true"
              input-type="number"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as=" "
              :placeholder="'Min'">
            </v-input>
          </p>
          <p class="control is-expanded column is-6">
            <v-input
              id="surface_max"
              :name="'surface_max'"
              @input="updateValueNumber($event, 'is_on__lte')"
              :model="valueCopy && valueCopy['is_on__lte'] || null"
              :number="true"
              input-type="number"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as=" "
              :placeholder="'Max'">
            </v-input>
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="customField.input_type === 'text'">
      <div class="field">
        <v-input
          :id="'customField-' + customField.title"
          :name="'customField-' + customField.title"
          @input="updateValue($event)"
          :model="valueCopy"
          :errors-bag="errors"
          data-vv-value-path="val"
          :data-vv-as="customField.title">
          <r-label
            slot="label"
            :is-required="customField.input_config.mandatory"
            :label="customField.title"
            :value="valueCopy"></r-label>
        </v-input>
      </div>
    </div>
    <div
      v-if="customField.input_type === 'date'">
      <date-picker
        v-if="!fromFilter"
        :model="valueCopy"
        :style-version="2"
        @input="updateValue($event)"
        :label="customField.title"
        :is-required="customField.input_config.mandatory"></date-picker>
      <date-picker
        v-else
        :model="{
          created_on__gte: valueCopy && valueCopy['created_on__gte'] || null,
          created_on__lte: valueCopy && valueCopy['created_on__lte'] || null
        }"
        :style-version="2"
        :is-range="true"
        :name="'date'"
        :placeholder="'Période'"
        :config="{mode: 'range'}"
        :label="customField.title"
        @input="updateValue($event)" />
    </div>
    <div
      v-if="customField.input_type === 'checkbox'">
      <r-label
        :label="customField.title"
        :value="valueCopy"
        :for-id="customField.title"
        :is-required="false"></r-label>
      <div class="">
        <input
          :id="customField.title"
          type="checkbox"
          :name="customField.title"
          class="switch is-success is-rounded is-medium"
          @input="updateValue($event.target.checked)"
          v-model="valueCopy">
        <label :for="customField.title">
          <span>{{ valueCopy ? 'Oui' : 'Non' }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomFieldInput',
  props: {
    customField: {
      type: Object,
      required: true
    },
    value: null,
    fromFilter: Boolean
  },
  data () {
    return {
      valueCopy: null
    }
  },
  watch: {
    'customField.input_type' (val) {
      if (val === 'checkbox') this.valueCopy = false
    }
  },
  created () {
    this.valueCopy = this.value
    if (this.customField.input_type === 'checkbox' && !this.value) {
      this.valueCopy = false
    }
  },
  updated () {
    this.valueCopy = this.value
  },
  methods: {
    updateValue (val) {
      let res
      if (this.customField.input_type === 'select') {
        res = this.customField.input_config.available_values.find(x => x.value === val)
        if (res === undefined) {
          res = null
        }
      } else if (this.customField.input_type === 'date' && this.fromFilter) {
        if (val[Object.keys(val)[0]] === null && val[Object.keys(val)[1]] === null) {
          res = null
        } else {
          res = val
        }
      } else res = val

      this.$emit('change', res)
    },
    updateValueNumber (val, key) {
      let res
      if (key === 'is_on__gte') {
        res = { is_on__gte: val }
      } else if (key === 'is_on__lte') {
        res = { is_on__lte: val }
      }
      this.$emit('change', res)
    }
  }
}
</script>
